import * as TFF from '@tff/types/TFF';
import { MetaValue } from '@tff/types/TFF/tfa-amend-ancillary-service';

interface AncillariesAccordion {
  type: string;
  ancillaries: MetaValue[];
}

/* 
  adds mock ssr object "BA0" to accordion data
  and
  create additional object with type "HAND_LUGGAGE
*/

export const updateGroupedRows = (
  prevRows: AncillariesAccordion[],
  intl,
  includedBaggage: TFF.Ancillary[],
): AncillariesAccordion[] => {
  if (prevRows.length < 2) {
    return prevRows;
  }

  const newRows = [...prevRows];

  const handBags: MetaValue[] = getHandLuggageElements(
    newRows.filter((i: AncillariesAccordion) => i.type === 'BAGGAGE'),
  );

  let baggageRow = newRows.find((element: AncillariesAccordion) => element.type === 'BAGGAGE')!;
  const additionalBaggageRow = newRows.find((element: AncillariesAccordion) => element.type === 'ADDITIONAL_BAGGAGE')!;

  const baggageExcludingHbag = baggageRow.ancillaries.filter((ancillary: MetaValue) => ancillary.code !== 'HBAG');
  const handLuggage: MetaValue = {
    code: 'BA0',
    type: 'BAGGAGE',
    shortDescription: intl.formatMessage({ id: 'ancillaries.edit.handLuggageOnly' }),
    price: {
      amount: 0,
      currency: '',
      regularAmount: 0,
    },
    airlineSsrCode: 'BA0',
    locale: '',
    restriction: { actualCapacityLeft: 99 },
  };

  let newBaggageAncillaries = [...baggageExcludingHbag, ...additionalBaggageRow.ancillaries];
  if (includedBaggage.length === 0) {
    newBaggageAncillaries.push(handLuggage);
  } else {
    includedBaggage.forEach(a =>
      newBaggageAncillaries.push({
        code: a.Type,
        type: 'BAGGAGE',
        shortDescription: `Included baggage only - ${a.Type}`,
        price: {
          amount: 0,
          currency: '',
          regularAmount: 0,
        },
        airlineSsrCode: a.Type,
        locale: '',
        restriction: { actualCapacityLeft: 99 },
      }),
    );
  }

  // Baggage row should contain baggage + additional baggage
  baggageRow.type = 'BAGGAGE';
  baggageRow.ancillaries = newBaggageAncillaries;

  // Since Additional Baggage is already in Check in luggage, we can remove this group
  const additionalBaggageIndex = newRows.indexOf(additionalBaggageRow);
  newRows.splice(additionalBaggageIndex, 1);

  //Add hand luggage as new type
  newRows.push({
    type: 'HAND_LUGGAGE',
    ancillaries: handBags,
  });

  return newRows;
};

const getHandLuggageElements = (possibleTypes: AncillariesAccordion[]) => {
  const hbagAncillaries: MetaValue[] = [];

  for (let i = 0; i < possibleTypes.length; i += 1) {
    const handLuggage = possibleTypes[i].ancillaries.find(ancillary => ancillary.code === 'HBAG');
    if (handLuggage) {
      hbagAncillaries.push(handLuggage);
    }
  }

  return hbagAncillaries;
};
